<template>
  <a-modal
    :visible="visible"
    :maskClosable="false"
    :title="title"
    :style="{ top: '300px'}"
    @cancel="handleCancel"
    @ok="handleOk"
    width="500px"
    okText="确定"
    cancelText="取消"
  >
    <!-- 步骤1：输入手机号 -->
    <div   class="form-container">
       
      <a-form layout="vertical">
        <a-form-item label="昵称">
          <a-input
            v-model:value="tgUserNickName"
            placeholder="请输入昵称"
          />
        </a-form-item>
 
      </a-form>
 
    </div>

  </a-modal>
</template>

<script lang="ts" setup>
import { ref,onMounted,inject,watch, reactive, defineProps, defineEmits } from "vue";
import { message } from "ant-design-vue";
import { TelegramClient } from "@/websocket/Client";
const client = TelegramClient.getInstance();
const tgUserNickName = ref("");
const title = ref("");
import { useStore } from 'vuex';
const store = useStore();
const targetIdsList = ref<any[]>([]);

 
const injectedData = inject('curSelectUser'); // 注入数据
// 表单相关
const taskForm = ref<{
  targetIds: string[];
}>({
  targetIds: [],
});

const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
  (e: "refreshFriendList"): void;
  (e: "success"): void;
}>();

 

// 发送验证码
const handleSendCode = async () => {
 
};

onMounted(() => {
  //tgUserNickName.value = "fda";
  //targetIdsList.value = [{name:"123",nickname:"123"},{name:"121",nickname:"121"}]
   //console.log("EditNameModal onMounted");
});

const handleCancel = () => {
  console.log("handleCancel");
  emit("update:visible", false);
};


const handleOk = () => {
  console.log("handleOk");
  if(tgUserNickName.value == "")
  {
     message.error(`请输入昵称`);
     return
  }
  handleEditUser();
  //emit("refreshFriendList");
};

const handleEditUser = async () => {
  
  const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    const result = await client.sendTelegramEditUserName(
      account,
      name,
      injectedData.value.userId,
      tgUserNickName.value
    );
    if(result.message&&result.message.code == 1)
    {
      message.info(result.message.msg);
      emit("refreshFriendList");
      handleCancel();
    }
    else if(result.message)
    {
      message.error(result.message.msg);
    }
    console.log("handleEditUser");
    
};


// 监听可见性变化
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
       console.log("injectedData.userId= "+injectedData.value.userId);
       title.value = "编辑联系人(" + injectedData.value.userNick + ")";

    }
  }
);

 
</script>

<style scoped>
.form-container {
  outline: none;
  padding: 10px;
}

.target-item {
  margin: 0;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.targets-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}
.targets-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

</style>
